import { render, staticRenderFns } from "./benefitenttl.vue?vue&type=template&id=24dfa1d9"
import script from "./benefitenttl.vue?vue&type=script&lang=js"
export * from "./benefitenttl.vue?vue&type=script&lang=js"
import style0 from "./benefitenttl.vue?vue&type=style&index=0&id=24dfa1d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports